import { DeclineManagedByPartnerConsentPayload, GiveConsentPayload } from '../actions/SettingsActions';
import config from '../config';
import { customUrlCustomFetch as fetch, urlWithQueryParams } from './fetch';
import getFetchHeaders from './getFetchHeaders';

const consentUrl = ({ path, ...extraParams }: { [extraParams: string]: string } = {}): URL =>
    urlWithQueryParams({
        path: `${config.apiUrl}/consent${path || ''}`,
        ...{
            ...extraParams,
        },
    });

export const declineManagedByPartnerConsent = async ({
    userGroupId,
}: DeclineManagedByPartnerConsentPayload): Promise<void> =>
    fetch<void>(
        consentUrl({
            path: '/managed-by-partner',
            userGroupId,
        }),
        {
            method: 'DELETE',
            headers: await getFetchHeaders(),
        }
    );

export const giveConsent = async ({ userGroupId, consentId }: GiveConsentPayload): Promise<void> =>
    fetch<void>(
        consentUrl({
            path: '/',
            partnerUserGroupId: userGroupId,
            consentId,
        }),
        {
            method: 'PUT',
            headers: await getFetchHeaders(),
        }
    );

export default { declineManagedByPartnerConsent };
